import { useTheme } from "next-themes";
import { Toaster as Sonner, toast as sonnerToast } from "sonner";
import { useDialogState } from "@/contexts/DialogContext";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group !bottom-28 md:!bottom-20 !z-[100]"
      closeButton={true}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:backdrop-blur-md group-[.toaster]:bg-background/80 group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground !opacity-100",
          closeButton: "!opacity-100 !text-foreground !bg-foreground/10 group-[.toast]:hover:!bg-foreground/20 group-[.toast]:hover:!text-foreground transition-colors border border-foreground/20 !w-6 !h-6",
        },
      }}
      {...props}
    />
  );
};

// Global flag to track dialog state (fallback for components not using the hook)
let isAnyDialogOpen = false;

export const setDialogOpen = (open: boolean) => {
  isAnyDialogOpen = open;
};

// Export toast directly from sonner without suppression logic
// Toasts will now show above dialogs with z-index 100
const toast = sonnerToast;

export { Toaster, toast, useDialogState };
